import CustomerFieldModel from '@/models/crm/CustomerFieldModel'
import CrmServiceCollection from '@/collections/CrmServiceCollection'

/**
 * Customer Field collection
 */
export default class CustomerFieldCollection extends CrmServiceCollection {

  // Model that is contained in this collection.
  model () {
    return CustomerFieldModel
  }

}
